import React, { Component } from 'react'
import {
  getFormSyncErrors,
  getFormValues,
  change,
  reset,
  untouch,
  touch,
  isValid,
  isDirty
} from 'redux-form'
import { connect } from 'react-redux'

import _ from 'lodash'
import flat from 'flat'
import qs from 'query-string'
import { MuiForm } from 'material-ui-elements'
import Grid from 'material-ui/Grid'
import DrawerContent from './DrawerContent'
import DrawerToolbar from './DrawerToolbar'
import History from './History'
import core from '../../core'
import { saveToAPI } from '../helpers'

const {
  helpers: { calculateAge, calculatePeriod, getLoginFromMail, getUserId },
  // constants: { API_URL },
  components: { NoMatch }
} = core

const { layouts } = MuiForm

class Detail extends Component {
  state = {}

  componentWillMount() {
    const { location } = this.props
    const search = location.search
    location.search = ''

    this.fetchToState(search)
  }

  componentWillReceiveProps(nextProps) {
    const activeSubFormName = nextProps.match.params.form || ''

    if (this.state.activeFormName !== activeSubFormName) {
      this.setState({ ...this.state, activeFormName: activeSubFormName })
    }
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.setState({ data: null })
      this.fetchToState('', nextProps.match.params.id)
    }
  }

  async fetchToState(search = '', nextId = null) {
    const {
      history: { push },
      sectionPath,
      config: { active, modified, errors },
      getData
    } = this.props
    const id = nextId || this.props.match.params.id
    const activeSubFormName = this.props.match.params.form || ''

    const data = await getData(id, undefined, true, '', 'detail')
    if (id !== 'new') {
      const detailEntry = _.find(data.data, ['id', _.toNumber(id)])

      const activeSection = {}
      active.map(s => {
        Object.assign(activeSection, {
          [`${s}Details`]:
            (detailEntry &&
              detailEntry[`${s}History`] &&
              detailEntry[`${s}History`].length - 1) ||
            null
        })
        return s
      })

      this.setState({
        ...this.state,
        data: {
          ...data,
          data: detailEntry
        },
        search,
        activeFormName: activeSubFormName,
        active: {
          ...activeSection
        },
        // active: {
        //   personDetails:
        //     detailEntry &&
        //     detailEntry.personHistory &&
        //     detailEntry.personHistory.length - 1,
        //   // parentsDetails: null,
        //   socialDetails:
        //     detailEntry &&
        //     detailEntry.socialHistory &&
        //     detailEntry.socialHistory.length - 1,
        //   placementDetails:
        //     detailEntry &&
        //     detailEntry.placementHistory &&
        //     detailEntry.placementHistory.length - 1,
        //   notesDetails:
        //     detailEntry &&
        //     detailEntry.notesHistory &&
        //     detailEntry.notesHistory.length - 1
        // },
        modified: [],
        errors: []
      })
      push(`${sectionPath}${id}/${activeSubFormName}`)
    } else {
      this.setState({
        ...this.state,
        data: {
          ...data,
          data: await this.initialData()
        },
        search,
        activeFormName: activeSubFormName,
        refresh: true,
        active: {
          ...active.map(s => {
            return {
              [`${s}Details`]: null
            }
          })
        },
        // active: {
        //   personDetails: null,
        //   // parentsDetails: null,
        //   socialDetails: null,
        //   placementDetails: null,
        //   notesDetails: null
        // },
        modified: modified || [],
        errors: errors || []
      })
      push(`${sectionPath}new/${activeSubFormName}`)
    }
  }

  initialData() {
    // const dobDate = new Date()
    const {
      config: { defaultNew }
    } = this.props
    return defaultNew
  }

  isDisabled() {
    return qs.parse(this.props.location.search).view !== 'edit'
  }

  //#######################################################
  // HANDLE SELECTION IN FORM
  //#######################################################

  proceedSelectionChange = (formName, selectionId) => {
    const {
      data: { persons }
    } = this.state
    const { change, touch, formValues } = this.props
    const {
      discharge: { dischargeDate },
      admission: { admissionDate }
    } = formValues

    const person =
      selectionId !== 'new'
        ? _.find(persons, ['id', selectionId])
        : this.initialData().person

    _.forOwn(flat.flatten(person), (value, key) => {
      change(formName, `person.${key}`, value)
    })
    change(
      formName,
      `person.fullName`,
      `${person.firstName} ${person.lastName}`
    )
    change(formName, `person.age`, calculateAge(person.dob))
    change(
      formName,
      `person.fullName`,
      `${person.firstName} ${person.lastName}`
    )
    change(
      formName,
      `admission.admissionAge`,
      calculatePeriod(person.dob, admissionDate)
    )
    change(
      formName,
      `discharge.dischargeAge`,
      calculatePeriod(person.dob, dischargeDate)
    )
    touch(formName, 'id')
    this.updateDetailsState(1, 'selection')
  }

  //######################################################
  // HANDLE HISTORY
  //######################################################

  updateDetailsState(activeFormId, type) {
    let modifiedAdjusted = this.state.modified
    let errorsAdjusted = this.state.errors
    switch (type) {
      case 'modified':
        if (!_.includes(modifiedAdjusted, activeFormId))
          modifiedAdjusted.push(activeFormId)
        if (_.includes(errorsAdjusted, activeFormId))
          _.remove(errorsAdjusted, n => n === activeFormId)
        break

      case 'errors':
        // if (_.includes(errorsAdjusted, activeFormId))
        //   _.remove(errorsAdjusted, n => n === activeFormId)
        if (!_.includes(errorsAdjusted, activeFormId))
          errorsAdjusted.push(activeFormId)

        break

      case 'selection':
        if (!_.includes(errorsAdjusted, activeFormId))
          errorsAdjusted.push(activeFormId)
        if (_.includes(modifiedAdjusted, activeFormId))
          _.remove(modifiedAdjusted, n => n === activeFormId)
        break

      default:
        modifiedAdjusted = []
        errorsAdjusted = []
        break
    }

    this.setState({
      modified: modifiedAdjusted,
      errors: errorsAdjusted
    })
  }

  updateState(historyName, activeName, active = null, reset = false) {
    const {
      formValues,
      change,
      constantProps: { FORM },
      location,
      history: { push }
    } = this.props
    const {
      data: { data }
    } = this.state

    const viewHistory = qs.parse(location.search).viewHistory === 'history'

    const detailData = !reset ? formValues || data : data
    const activeIndex =
      active !== null
        ? active
        : detailData[`${historyName}`]
          ? detailData[`${historyName}`].length - 1
          : null
    if (active === null && viewHistory) push(location.pathname) //console.log('push')

    this.setState({
      ...this.state,
      active: { ...this.state.active, [`${activeName}Details`]: activeIndex }
    })

    if (activeIndex !== null && activeIndex >= 0) {
      this.changeActive(
        activeIndex,
        FORM,
        historyName,
        activeName,
        formValues || data,
        change
      )
    }
  }

  changeActive = (
    activeIndex,
    formName,
    historyName,
    activeName,
    detailData,
    change
  ) => {
    const activeHistory = detailData[`${historyName}`][activeIndex]

    _.forOwn(activeHistory, (value, key) => {
      change(`${formName}`, `${activeName}.${key}`, value)
    })
  }

  addHistory = (
    formName,
    historyName,
    activeName,
    detailData,
    change,
    formValues,
    editType
  ) => {
    const history = formValues[`${historyName}`]

    const newHistory =
      _.get(
        history,
        `[${_.findIndex(history, ['audit.active', true])}].historyId`
      ) !== 'new'

    const activeHistory = formValues[`${activeName}`]
    const audit = {
      active: true,
      editType: (editType && editType * 1) || 1,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }

    let value = activeHistory
    value.audit = audit

    const newIndex = history.length
    const oldActiveIndex = _.findIndex(history, ['audit.active', true])

    if (newHistory) {
      change(`${formName}`, `${activeName}.historyId`, 'new')
      change(`${formName}`, `${historyName}[${newIndex}]`, value)
      change(`${formName}`, `${historyName}[${newIndex}].historyId`, 'new')
      change(`${formName}`, `${historyName}[${newIndex}].audit`, audit)
      if (oldActiveIndex > -1)
        change(
          `${formName}`,
          `${historyName}[${oldActiveIndex}].audit.active`,
          null
        )
      const valueAdjusted = { ...value, historyId: 'new', audit: audit }
      const historyAdj = _.get(formValues, `${historyName}`)
      historyAdj.push(valueAdjusted)
      const activeObj = _.get(formValues, `${activeName}`)

      const formValuesAdjusted = {
        ...formValues,
        [`${activeName}`]: {
          ...activeObj,
          historyId: 'new'
        },
        [`${historyName}`]: historyAdj
      }

      this.setState({
        active: { ...this.state.active, [`${activeName}Details`]: newIndex }
      })
      return formValuesAdjusted
    } else {
      change(`${formName}`, `${historyName}[${oldActiveIndex}]`, value)
    }
  }

  //######################################################
  // RENDER
  //######################################################

  render() {
    const { data, activeFormName } = this.state
    if (!data) return null
    if (_.isEmpty(data.data)) return <NoMatch style={{ marginTop: 200 }} />

    const {
      history: { push },
      location,
      match: {
        params: { id }
      },
      constantProps: { PATH, DATE_FORMAT, FORM },
      config: { valueTable },
      subFormsDispatcher,
      sectionPath,
      snackbar,
      change,
      // reset,
      formValues
    } = this.props

    const detailEntry = data.data
    const centres = data.centres
    const reasons = data.reasons
    const persons = data.persons

    const disabled = this.isDisabled()
    const add = id === 'new'

    const personOptions = _.orderBy(persons, ['lastName'], ['asc'])
    if (!_.find(personOptions, ['id', 'new']))
      personOptions.unshift({
        id: 'new',
        label: 'New Person'
      })

    const forms = subFormsDispatcher({
      sectionPath: sectionPath, //'register',
      data: {
        centres,
        persons: personOptions,
        reasons
      },
      fields: MuiForm.fields,
      change,
      formName: FORM,
      disabled,
      add,
      formValues,
      showAsterix: false,
      openToYearSelection: true,
      hideCalendarDate: true,
      proceedSelectionChange: this.proceedSelectionChange,
      personAdd: formValues.person && formValues.person.id === 'new',
      availableValues: { ...valueTable, ...data },
      ...this.props,
      ...this.state
    })

    const viewEdit = qs.parse(location.search).view !== 'edit'
    const editType = qs.parse(location.search).editType

    const active = activeFormName
      ? _.findIndex(forms, ['name', activeFormName])
      : 0
    const activeForm = active > -1 ? forms[active] : undefined
    const oldSearch = this.state.search

    const historyName = activeForm.historyName
    const activeName = activeForm.activeName

    const activeFormHistory = _.orderBy(
      formValues && formValues[`${historyName}`]
        ? formValues[`${historyName}`]
        : detailEntry[`${historyName}`],
      ['audit.createdDate', 'audit.modifiedDate'],
      ['asc', 'asc']
    )

    const activeHistoryDetails = forms.map(
      (f, i) => this.state.active[`${f.activeName}Details`]
    )

    const activePerson = detailEntry.person || detailEntry //!!! VERIFY || detailEntry
    let label = ''
    if (
      _.includes(sectionPath, '/register/') ||
      _.includes(sectionPath, '/personnel/')
    ) {
      label = `${activePerson.firstName} ${activePerson.lastName}${
        activePerson.initials ? ` (${activePerson.initials})` : ''
      }`
    } else if (_.includes(sectionPath, '/centres/')) {
      const centre = detailEntry
      label = `${centre.name}`
    }

    label = add ? 'New Entry' : label

    return (
      <div className="App">
        {activeForm ? (
          <Grid
            container
            style={{
              marginLeft: 302,
              marginTop: 52, //143,
              width: 'calc(100% - 294px)'
            }}
          >
            <Grid item lg={12}>
              <MuiForm
                layout={layouts.drawer}
                data={activeFormHistory} //historyData} // TODO
                fieldWidths={{
                  config: {
                    family: 'Roboto',
                    size: 9,
                    extraWidth: 15
                  }
                }}
                active={activeHistoryDetails} //TODO
                // expanded //={activeForm.id !== 2}
                styles={{ titleStyles: { fontSize: '0.85rem' } }}
                toolbarTopStyles={{
                  color: '#808080',
                  fontSize: '1.1rem',
                  fontWeight: 550
                }}
                info={
                  // disabled &&
                  forms.map((f, i) => {
                    return (
                      disabled &&
                      formValues[`${f.historyName}`] &&
                      formValues[`${f.historyName}`].length > 1 && {
                        historyName: f.historyName,
                        activeName: f.activeName,
                        activeForm: activeForm,
                        icon: 'history',
                        label: 'View History',
                        component: History,
                        action: this.updateState.bind(this)
                      }
                    )
                  })
                }
                drawer={{
                  component: DrawerContent,
                  drawerToolbarComponent: !add ? DrawerToolbar : null,
                  drawerProps: {
                    path: PATH,
                    forms: forms,
                    title: label,
                    modified: this.state.modified,
                    activeForm: activeForm,
                    updateDetailsState: this.updateDetailsState.bind(this),
                    errors: this.state.errors,
                    disabled: disabled,
                    add,
                    ...this.props
                  }
                }}
                name={FORM} //"YoungPerson"
                add={add}
                disabled={this.isDisabled() && !add}
                title={label} //{activeForm.label.toUpperCase()}
                initialValues={detailEntry}
                // fields={activeForm.fields}
                groups={forms}
                dateFormat={DATE_FORMAT}
                actions={
                  !add
                    ? {
                        edit:
                          (formValues[`${activeName}`] &&
                            formValues[`${activeName}`].audit &&
                            formValues[`${activeName}`].audit.active) ||
                          (!add && _.isEmpty(formValues[`${activeName}`]))
                            ? () => {
                                push(
                                  `${PATH}${id}/${activeForm.name}?view=edit`
                                )
                                this.forceUpdate()
                              }
                            : null,
                        save: async data => {
                          let result = formValues
                          if (formValues[`${historyName}`]) {
                            result = this.addHistory(
                              FORM,
                              historyName,
                              activeName,
                              detailEntry,
                              change,
                              data,
                              editType
                            )
                          }
                          this.updateDetailsState(activeForm.id, 'modified')

                          await saveToAPI({
                            state: this.state,
                            props: this.props,
                            formValues: result,
                            forms,
                            id,
                            push,
                            snackbar,
                            PATH,
                            oldSearch,
                            persons,
                            editType
                          })
                          // push(`${PATH}${id}/${activeForm.name}`)
                        },
                        undo: !viewEdit
                          ? () => {
                              this.updateState(historyName, activeName)
                              // _.forOwn(flat.flatten(formValues), (value, key) => {
                              //   this.props.untouch(FORM, `${key}`)
                              // })
                              push(`${PATH}${id}/${activeForm.name}`)
                            }
                          : null,

                        cancel: () => {
                          push(`${PATH}${oldSearch ? oldSearch : ''}`)
                        }
                      }
                    : {
                        customButtons: {
                          buttons: [
                            {
                              action: async data => {
                                // this.updateDetailsState(
                                //   activeForm.id,
                                //   'modified'
                                // )
                                const modified = forms
                                  .filter(f => f.id > 1)
                                  .map(o => o.id)
                                await saveToAPI({
                                  state: this.state,
                                  props: this.props,
                                  formValues,
                                  forms,
                                  id,
                                  push,
                                  snackbar,
                                  PATH,
                                  oldSearch,
                                  persons,
                                  modified,
                                  editType
                                })
                              },
                              icon: 'save',
                              label: 'Save changes',
                              disabled:
                                !_.isEmpty(this.props.syncErrors) ||
                                this.props.isDirty(FORM)

                              // !_.includes(
                              //   this.state.modified,
                              //   activeForm.id
                              // )
                            },
                            {
                              //cancel
                              action: () => {
                                push(`${PATH}${oldSearch ? oldSearch : ''}`)
                              },
                              icon: 'cancel',
                              label: `Cancel${add ? ' update' : ''}`,
                              // style: {
                              //   display: !_.isEmpty(this.state.modified) ? '' : 'none'
                              // },
                              raised: true
                            }
                          ]
                        }
                      }
                }
              />
            </Grid>
          </Grid>
        ) : null}
      </div>
    )
  }
}

export default connect(
  (state, ownProps) => {
    const {
      constantProps: { FORM }
    } = ownProps
    return {
      formValues: getFormValues(FORM)(state) ? getFormValues(FORM)(state) : '',
      syncErrors: getFormSyncErrors(FORM)(state)
        ? getFormSyncErrors(FORM)(state)
        : ''
    }
  },
  { change, isValid, isDirty, untouch, reset, touch, getFormValues }
)(Detail)

// export default Detail



// WEBPACK FOOTER //
// ./src/common/components/Detail.js